import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "./Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

const SOCIALS = [
  { name: "LinkedIn", url: "https://www.linkedin.com/company/origin-bureau" },
  { name: "Instagram", url: "https://www.instagram.com/originbureau" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="noise-overlay bg-ink text-ivory">
    <div className="relative z-10 mx-auto max-w-7xl px-6 pb-10 pt-20 md:px-12 md:pt-28">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <LogoMark stroke="#FAFAF9" className="h-9 w-9" />
            <span className="flex flex-col leading-none">
              <span className="font-label text-sm font-extrabold tracking-[0.3em]" style={{ color: "#D9481C" }}>ORIGIN</span>
              <span className="mt-1.5 font-label text-[10px] font-extrabold tracking-[0.44em]" style={{ color: "#D9481C" }}>BUREAU</span>
            </span>
          </div>
          <p className="mt-6 max-w-sm font-serif text-2xl leading-snug text-stone-300">
            Sourcing. Development. Production. <span className="italic text-terra-light">India.</span>
          </p>
          <a
            href="mailto:nupur@obofficial.in"
            data-testid="footer-email"
            className="link-line mt-6 inline-block font-label text-xs font-semibold uppercase tracking-[0.22em] text-stone-400 transition-colors duration-300 hover:text-ivory"
          >
            nupur@obofficial.in
          </a>
        </div>
        <div className="md:col-span-3">
          <p className="font-label text-[11px] font-semibold uppercase tracking-[0.28em] text-stone-500">Navigate</p>
          <ul className="mt-6 space-y-3">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  className="font-serif text-lg text-stone-300 transition-colors duration-300 hover:text-terra-light"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-label text-[11px] font-semibold uppercase tracking-[0.28em] text-stone-500">Follow</p>
          <ul className="mt-6 space-y-3">
            {SOCIALS.map((s) => (
              <li key={s.name}>
                <a
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  className="group inline-flex items-center gap-1.5 font-serif text-lg text-stone-300 transition-colors duration-300 hover:text-terra-light"
                >
                  {s.name}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-20 select-none overflow-hidden">
        <p className="whitespace-nowrap font-serif text-[13vw] leading-none text-stone-800/60 md:text-[9vw]">ORIGIN BUREAU</p>
      </div>
      <div className="mt-8 flex flex-col gap-3 border-t border-stone-800 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-label text-[11px] uppercase tracking-[0.2em] text-stone-500" data-testid="footer-copyright">
          © 2026 Origin Bureau. All rights reserved.
        </p>
        <p className="font-label text-[11px] uppercase tracking-[0.2em] text-stone-500">
          Your partner in India
        </p>
        <Link to="/admin" data-testid="footer-admin-link" className="font-label text-[11px] uppercase tracking-[0.2em] text-stone-600 transition-colors duration-300 hover:text-stone-400">
          Studio
        </Link>
      </div>
    </div>
  </footer>
);
